import {AppState} from './../../../store';
import {createSelector} from 'reselect';

export const homeSelector = (state: AppState) => state.home;

export const offersApiSelectorFn = createSelector(homeSelector, item => item.offersApi);

export const isOffersApiLoadingSelectorFn = createSelector(
  offersApiSelectorFn,
  item => item.isLoading,
);

export const offersDataSelectorFn = createSelector(offersApiSelectorFn, item => item.data);

export const hotelsHomeSeoData = createSelector(homeSelector, item => item.homeSeoData);
